import * as Types from '../../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ArchivedProvingsQueryVariables = {};


export type ArchivedProvingsQuery = (
  { __typename?: 'Query' }
  & { provings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_deleted' | 'id' | '_id' | 'type' | 'status' | 'title' | 'description' | 'dateTo' | 'dateFrom' | 'created' | 'department'>
    & { participants: Types.Maybe<Array<(
      { __typename?: 'Participant' }
      & Pick<Types.Participant, '_id' | 'orderId' | 'dateTo' | 'dateFrom' | 'percentage' | 'trackHotelRequired' | 'group' | 'temporaryPass' | 'passActivation' | 'permanentDriveAuthorization' | 'singleDriveAuthorization' | 'dvEquipment' | 'partsTransport' | 'driverTraining' | 'nordschleife' | 'nordschleifeBookingStatus'>
      & { person: Types.Maybe<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id' | 'type' | 'name' | 'lastName' | 'firstName'>
      ) | (
        { __typename?: 'Worker' }
        & Pick<Types.Worker, '_id' | 'type' | 'name' | 'lastName' | 'firstName'>
      )>, unknownPerson: Types.Maybe<(
        { __typename?: 'UnknownPerson' }
        & Pick<Types.UnknownPerson, 'isUnknown' | 'personType' | 'department' | 'supplier' | 'employee' | 'firstName' | 'surName'>
      )>, flight: Types.Maybe<(
        { __typename?: 'Flight' }
        & Pick<Types.Flight, 'flightType' | 'bookingStatus'>
      )>, accomodation: Types.Maybe<(
        { __typename?: 'Accomodation' }
        & Pick<Types.Accomodation, 'accomodationType' | 'dateFrom' | 'dateTo' | 'bookingStatus'>
        & { accomodation: Types.Maybe<(
          { __typename?: 'Lodging' }
          & Pick<Types.Lodging, '_id' | 'title'>
        )> }
      )>, trackHotels: Types.Maybe<(
        { __typename?: 'TrackHotels' }
        & { outward: Types.Maybe<Array<(
          { __typename?: 'TrackHotel' }
          & Pick<Types.TrackHotel, '_id' | 'dateFrom' | 'dateTo' | 'bookingStatus'>
          & { hotel: Types.Maybe<(
            { __typename?: 'Lodging' }
            & Pick<Types.Lodging, '_id' | 'title' | 'inactive'>
          )> }
        )>>, return: Types.Maybe<Array<(
          { __typename?: 'TrackHotel' }
          & Pick<Types.TrackHotel, '_id' | 'dateFrom' | 'dateTo' | 'bookingStatus'>
          & { hotel: Types.Maybe<(
            { __typename?: 'Lodging' }
            & Pick<Types.Lodging, '_id' | 'title' | 'inactive'>
          )> }
        )>> }
      )>, rentalCar: Types.Maybe<(
        { __typename?: 'RentalCar' }
        & Pick<Types.RentalCar, 'dateTo' | 'dateFrom' | 'carType' | 'bookingStatus'>
      )>, ferry: Types.Maybe<(
        { __typename?: 'Ferry' }
        & Pick<Types.Ferry, 'dateTo' | 'timeTo' | 'dateFrom' | 'timeFrom' | 'bookingStatus'>
        & { outward: Types.Maybe<(
          { __typename?: 'FerryConnection' }
          & Pick<Types.FerryConnection, '_id' | 'title' | 'type' | 'inactive' | 'origin' | 'destination'>
        )>, return: Types.Maybe<(
          { __typename?: 'FerryConnection' }
          & Pick<Types.FerryConnection, '_id' | 'title' | 'type' | 'inactive' | 'origin' | 'destination'>
        )> }
      )> }
    )>>, createdBy: (
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    ), editor: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    )>>, responsible: Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    )>, resourceManager: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    )>>, provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title'>
    )> }
  )> }
);

export const ArchivedProvingsDocument = gql`
    query ArchivedProvings {
  provings(filter: {status: {EQ: 8}}) {
    _deleted
    id
    _id
    type
    status
    title
    description
    dateTo
    dateFrom
    created
    department
    participants {
      _id
      person {
        _id
        type
        name
        lastName
        firstName
      }
      unknownPerson {
        isUnknown
        personType
        department
        supplier
        employee
        firstName
        surName
      }
      orderId
      dateTo
      dateFrom
      percentage
      flight {
        flightType
        bookingStatus
      }
      accomodation {
        accomodationType
        accomodation {
          _id
          title
        }
        dateFrom
        dateTo
        bookingStatus
      }
      trackHotelRequired
      trackHotels {
        outward {
          _id
          dateFrom
          dateTo
          hotel {
            _id
            title
            inactive
          }
          bookingStatus
        }
        return {
          _id
          dateFrom
          dateTo
          hotel {
            _id
            title
            inactive
          }
          bookingStatus
        }
      }
      rentalCar {
        dateTo
        dateFrom
        carType
        bookingStatus
      }
      group
      temporaryPass
      passActivation
      permanentDriveAuthorization
      singleDriveAuthorization
      dvEquipment
      partsTransport
      driverTraining
      ferry {
        outward {
          _id
          title
          type
          inactive
          origin
          destination
        }
        return {
          _id
          title
          type
          inactive
          origin
          destination
        }
        dateTo
        timeTo
        dateFrom
        timeFrom
        bookingStatus
      }
      nordschleife
      nordschleifeBookingStatus
    }
    createdBy {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    editor {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    responsible {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    resourceManager {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    provingGround {
      _id
      title
    }
  }
}
    `;

    export function useArchivedProvingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ArchivedProvingsQuery, ArchivedProvingsQueryVariables>) {
      return ApolloReactHooks.useQuery<ArchivedProvingsQuery, ArchivedProvingsQueryVariables>(ArchivedProvingsDocument, baseOptions);
    };
      export function useArchivedProvingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArchivedProvingsQuery, ArchivedProvingsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ArchivedProvingsQuery, ArchivedProvingsQueryVariables>(ArchivedProvingsDocument, baseOptions);
      };
      
export type ArchivedProvingsQueryHookResult = ReturnType<typeof useArchivedProvingsQuery>;
export type ArchivedProvingsQueryResult = ApolloReactCommon.QueryResult<ArchivedProvingsQuery, ArchivedProvingsQueryVariables>;